import { Component, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProfileService } from 'src/app/services/profile.service';

import { IEmailConfirmation } from './interfaces/email-confirmation';

@Component({
  selector: 'opt-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss'],
})
export class ConfirmEmailComponent implements OnInit {
  public confirmation: IEmailConfirmation = null;
  public codeError = false;
  public isLoading = true;
  public confirmForm: UntypedFormGroup = null;

  constructor(
    private dialogRef: MatDialogRef<ConfirmEmailComponent>,
    private profileService: ProfileService
  ) {}

  public get confirmationCode() {
    return this.confirmForm.get('confirmationCode')?.value;
  }
  public get submitDisabled() {
    return !this.confirmForm || !this.confirmForm.valid;
  }

  ngOnInit(): void {
    this.init();
  }

  public onSubmit(): void {
    if (!this.confirmForm.valid) {
      return;
    }

    this.isLoading = true;
    this.profileService
      .validateConfirmationCode(this.confirmationCode)
      .subscribe(
        (result) => {
          if (result) {
            this.dialogRef.close(true);
          } else {
            this.codeError = true;
          }
        },
        (error) => {
          console.error(error);
        },
        () => {
          this.isLoading = false;
        }
      );
  }

  public onCancel(): void {
    this.dialogRef.close(false);
  }

  private init(): void {
    this.isLoading = true;
    this.profileService.requestConfirmationEmail().subscribe(
      (result) => {
        if (!result?.email) {
          this.dialogRef.close(true);
        }

        this.confirmation = result;
        this.initForm();
      },
      (error) => {
        console.error(error);
        this.dialogRef.close(false);
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  private initForm(): void {
    this.confirmForm = new UntypedFormGroup({
      confirmationCode: new UntypedFormControl(null, [
        Validators.required,
        Validators.maxLength(6),
        Validators.minLength(6),
      ]),
    });
  }
}
